import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Package, ChevronDown, ChevronUp, Truck, CheckCircle, Clock, ArrowRight } from 'lucide-react';
import Header from './components/Header3';
import Footer from './components/Footer3';

const Orders3 = () => {
    const navigate = useNavigate();
    const [expandedOrder, setExpandedOrder] = useState(null);
    const [showEmpty, setShowEmpty] = useState(false);

    const orders = [
        {
            id: 'VSTR-2026001', date: '15 Mar 2026', status: 'delivered', total: 49999,
            items: [{ name: 'Royal Banarasi Lehenga', quantity: 1, size: 'M', price: 49999, image: 'https://images.pexels.com/photos/2681751/pexels-photo-2681751.jpeg?auto=compress&cs=tinysrgb&w=800' }],
            shippingAddress: '45 Heritage Lane, Jaipur, Rajasthan 302001', trackingNumber: 'VSTR-TRK-78291', deliveredDate: '18 Mar 2026',
        },
        {
            id: 'VSTR-2026002', date: '10 Mar 2026', status: 'in_transit', total: 50500,
            items: [
                { name: 'Silk Chanderi Saree', quantity: 1, size: 'Free Size', price: 18500, image: 'https://images.pexels.com/photos/1536619/pexels-photo-1536619.jpeg?auto=compress&cs=tinysrgb&w=800' },
                { name: 'Gold Zardozi Sherwani', quantity: 1, size: 'L', price: 32000, image: 'https://images.pexels.com/photos/3014853/pexels-photo-3014853.jpeg?auto=compress&cs=tinysrgb&w=800' },
            ],
            shippingAddress: '12 MG Road, Delhi 110001', trackingNumber: 'VSTR-TRK-78405', expectedDelivery: '22 Mar 2026',
        },
        {
            id: 'VSTR-2026003', date: '5 Mar 2026', status: 'processing', total: 15999,
            items: [{ name: 'Maroon Velvet Anarkali', quantity: 1, size: 'S', price: 15999, image: 'https://images.pexels.com/photos/4614070/pexels-photo-4614070.jpeg?auto=compress&cs=tinysrgb&w=800' }],
            shippingAddress: '78 Jubilee Hills, Hyderabad 500033', expectedDelivery: '25 Mar 2026',
        },
    ];

    const statusConfig = {
        delivered: { label: 'Delivered', color: '#2ECC71', icon: CheckCircle },
        in_transit: { label: 'In Transit', color: '#B8860B', icon: Truck },
        processing: { label: 'Processing', color: '#722F37', icon: Clock },
    };

    const isEmpty = showEmpty || orders.length === 0;

    return (
        <>
            <style>{`@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;500;600;700&family=Lato:wght@300;400;700&display=swap');`}</style>
            <div style={{ fontFamily: "'Lato', sans-serif" }} className="min-h-screen bg-[#FFFDF7]">
                <Header />
                <main className="pt-24 pb-16 px-4 lg:px-8">
                    <div className="max-w-[1000px] mx-auto">
                        <div className="mb-10">
                            <p className="text-[#B8860B] text-xs font-bold tracking-[0.3em] uppercase mb-3">Your Account</p>
                            <h1 style={{ fontFamily: "'Playfair Display', serif" }} className="text-3xl lg:text-5xl font-bold text-[#722F37]">My Orders</h1>
                        </div>

                        {isEmpty ? (
                            <div className="flex flex-col items-center justify-center py-24">
                                <div className="w-24 h-24 border border-[#E8E0D8] rounded-full flex items-center justify-center mb-8">
                                    <Package className="w-10 h-10 text-[#6B7280]" />
                                </div>
                                <h2 style={{ fontFamily: "'Playfair Display', serif" }} className="text-2xl font-bold text-[#722F37] mb-3">No orders yet</h2>
                                <p className="text-[#6B7280] text-sm mb-8 text-center max-w-sm">Start exploring our collections to place your first order.</p>
                                <button onClick={() => navigate('/template3/shop')} className="inline-flex items-center gap-2 px-8 py-3 text-sm font-bold tracking-wider uppercase" style={{ border: '1px solid #722F37', color: '#722F37' }}>
                                    Browse Collection <ArrowRight className="w-4 h-4" />
                                </button>
                            </div>
                        ) : (
                            <div className="space-y-4">
                                {orders.map(order => {
                                    const status = statusConfig[order.status];
                                    const StatusIcon = status.icon;
                                    const isExpanded = expandedOrder === order.id;
                                    return (
                                        <div key={order.id} style={{ backgroundColor: '#FFFFFF', border: '1px solid #E8E0D8' }}>
                                            <button onClick={() => setExpandedOrder(isExpanded ? null : order.id)} className="w-full flex items-center justify-between p-4 lg:p-6">
                                                <div className="flex items-center gap-4">
                                                    <div className="w-10 h-10 flex items-center justify-center" style={{ backgroundColor: `${status.color}15`, border: `1px solid ${status.color}30` }}>
                                                        <StatusIcon size={18} style={{ color: status.color }} />
                                                    </div>
                                                    <div className="text-left">
                                                        <p className="text-sm font-bold" style={{ color: '#1A1A1A' }}>{order.id}</p>
                                                        <p className="text-xs" style={{ color: '#6B7280' }}>{order.date}</p>
                                                    </div>
                                                </div>
                                                <div className="flex items-center gap-4">
                                                    <div className="text-right hidden lg:block">
                                                        <p className="text-sm font-bold" style={{ color: '#B8860B' }}>{`\u20B9${order.total.toLocaleString('en-IN')}`}</p>
                                                        <p className="text-xs font-bold" style={{ color: status.color }}>{status.label}</p>
                                                    </div>
                                                    {isExpanded ? <ChevronUp size={18} style={{ color: '#6B7280' }} /> : <ChevronDown size={18} style={{ color: '#6B7280' }} />}
                                                </div>
                                            </button>

                                            {isExpanded && (
                                                <div className="px-4 lg:px-6 pb-6" style={{ borderTop: '1px solid #E8E0D8' }}>
                                                    <div className="pt-4 space-y-3">
                                                        {order.items.map((item, idx) => (
                                                            <div key={idx} className="flex gap-4 p-3" style={{ border: '1px solid #E8E0D8' }}>
                                                                <img src={item.image} alt={item.name} className="w-16 h-20 object-cover" />
                                                                <div className="flex-1">
                                                                    <h4 className="text-sm font-bold" style={{ color: '#1A1A1A' }}>{item.name}</h4>
                                                                    <p className="text-xs mt-1" style={{ color: '#6B7280' }}>Size: {item.size} | Qty: {item.quantity}</p>
                                                                    <p className="text-sm font-bold mt-1" style={{ color: '#B8860B' }}>{`\u20B9${item.price.toLocaleString('en-IN')}`}</p>
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </div>
                                                    <div className="mt-4 p-3 text-xs" style={{ backgroundColor: '#FFF9F0', border: '1px solid #E8E0D8' }}>
                                                        <p className="font-bold mb-1" style={{ color: '#1A1A1A' }}>Shipping Address</p>
                                                        <p style={{ color: '#6B7280' }}>{order.shippingAddress}</p>
                                                        {order.trackingNumber && <p className="mt-2" style={{ color: '#722F37' }}>Tracking: {order.trackingNumber}</p>}
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    );
                                })}
                            </div>
                        )}
                    </div>
                </main>
                <Footer />
            </div>
        </>
    );
};

export default Orders3;
